import * as ListingDocumentType1 from "./ListingDocumentType1";
import * as ListingDocument6 from "./ListingDocument6";
import * as t from "io-ts";

export const codec = t.type({
    id: t.string,
    name: t.string,
    file_extension: t.string,
    document_type: ListingDocumentType1.codec,
    mime_type: t.string,
});

export type T = t.TypeOf<typeof codec>;

export const fromListingDocument6 = (m: ListingDocument6.T): T => (
    {
        id: m.id,
        name: m.name,
        file_extension: m.file_extension,
        document_type: m.document_type,
        mime_type: m.mime_type,
    }
);
